import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {action} from 'redux/helpers';
import {settingsTypes} from 'redux/settings';
import {IAdminRole} from 'types/diplomat/settings/adminroles/AdminRole';

export const useCreateAdminRole = (role?: IAdminRole) => {
   const dispatch = useDispatch();
   const create = useCallback(() => {
      dispatch(action(settingsTypes.CREATE_ADMIN_ROLE.SAGA, role));
   }, [dispatch, role]);

   return create;
};
